import { combineReducers } from "@reduxjs/toolkit";

import authenticator from "./userSlice";
import groupManager from "./groupSlice";
import scraperHandler from "./scraperSlice";
import historian from "./searchHistorySlice";
import tracker from "./searchSlice";
import updater from "./sidebarSlice";
import exporter from "./exportSlice";
import userStatus from "./userStatusSlice";
import errorTracker from "./globalErrorSlice";

const rootReducer = combineReducers({
  authenticator,
  groupManager,
  scraperHandler,
  historian,
  tracker,
  updater,
  exporter,
  userStatus,
  errorTracker,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
